import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ccf6b4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "board-map-wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["id"]

import L from 'leaflet'
import {
  ref,
  onMounted,
  onUnmounted,
  nextTick,
} from 'vue'
import { createMap, getDeviceClass } from '@/utils/map.utils'
import Text from '@/components/text'
import { queryBoardLocationDetail } from '@/api'
import { CODE_ENUM } from '@/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'b-map',
  props: ['id', 'name'],
  emits: 'on-edit',
  setup(__props, { emit: $emit }) {

const props = __props;




const command = (command: string) => {
  $emit(command)
}

const mapId = ref('map-')
let map: any = null
onMounted(async () => {
  const id = mapId.value + Math.random()
  mapId.value = id

  nextTick(() => {
    map = createMap(id)
    queryLocation()
  })
})

const deviceList = ref([])
const queryLocation = async () => {
  const id = props.id
  const res: any = await queryBoardLocationDetail({
    id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    deviceList.value = res.data || []

    renderDeviceList()
  }
}

const renderDeviceList = () => {
  deviceList.value.forEach((device: any) => {
    const marker: any = createMarker(device)
    marker.addTo(map)
  })

  const lnglat = deviceList.value.map(({ longitude, latitude }: any) => {
    return {
      lng: longitude,
      lat: latitude,
    }
  })
  map.fitBounds(lnglat, { padding: [25, 25] })
}

const createMarker = (device: any) => {
  const { latitude, longitude, picCode } = device
  const marker = L.marker([latitude, longitude], {
    icon: new L.divIcon({
      iconSize: [49, 62],
      iconAnchor: [25, 60],
      className: 'map-' + picCode,
    }),
  })
  return marker
}

return (_ctx: any,_cache: any) => {
  const _component_MoreFilled = _resolveComponent("MoreFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Text), {
        content: props.name
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.name), 1)
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_component_el_dropdown, {
        onCommand: command,
        size: "small",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { command: "on-edit" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.bedit')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { command: "on-delete" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.bdel')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { class: "icon" }, {
            default: _withCtx(() => [
              _createVNode(_component_MoreFilled)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: "map",
      id: mapId.value
    }, null, 8, _hoisted_3)
  ]))
}
}

})